import { useState } from 'react';

const useDialog = (props) => {
    const [show, setShow] = useState(props.showDialog);
    const [data, setData] = useState({});

    const onClose = () => {
        setShow(false);
    };

    const onSubmit = (_data) => {
        if (props.onSubmit) {
            props.onSubmit(_data);
        }
        setShow(false);
    };

    const openDialog = (_data) => {
        setData(_data);
        setShow(true);
    };

    return {
        show,
        setShow,
        data,
        openDialog,
        onSubmit,
        onClose,
    };
};

export default useDialog;
